import {Type} from '@mintdata/mint-kit/api/types/Type';
import {ErrorOrEmpty} from '@mintdata/mint-kit/api/types/Value';
import {AIntegerEnum} from '@mintdata/mint-kit/api/values/AIntegerEnum';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {BaseCoercionUtil} from '@mintdata/mint-kit/impl/coercionUtils/BaseCoercionUtil';

export class StringEnumCoercionUtil extends BaseCoercionUtil
{
    constructor()
    {
        super(Type.StringEnum);
    }

    public toString(from:AIntegerEnum):AString | ErrorOrEmpty
    {
        return new AString('' + from.value);
    }
}
